import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { LanguagePipe } from '../../services/language.pipe';
import { NotificationService } from '../../services/notification.service';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatService } from '../../services/chat.service';
import { BusinessEventService } from '../../services/business-event.service';
import { TurnService } from '../../services/turn.service';

declare var $;

@Component({
  selector: 'app-call',
  templateUrl: './call.component.html',
  styleUrls: ['./call.component.css']
})
export class CallComponent implements OnInit {

  @Output() isCallLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  public enableRecallButton: boolean = false;
  public enableCallButton: boolean = false;
  public selectedDesk: number = null;
  public socketRetries: number = 0;
  private ioConnection: any;
  private subscriptionClose: Subscription;
  private subscriptionOpen: Subscription;
  public callLoading: boolean = false;

  private destroy$ = new Subject();

  constructor(public _data: DataService,
    private _lang: LanguagePipe,
    private _blogic: BusinesLogicService,
    private _bevent: BusinessEventService,
    private _notify: NotificationService,
    private _turn: TurnService,
    private _chat: ChatService) { }

  ngOnInit() {
    this._updateTurn(this._data.turn);
    this._data.turnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._updateTurn(response);
        }
      );

    this._selectedUpdateTurn(this._data.selectedTurn);
    this._data.selectedTurnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._selectedUpdateTurn(response);
        }
      );

    this._isWaiting();
    this._turn.startDeskAutomations();

    if (this._data.inQueue != 0
      && this._data.configuration["getTurnToInit"]
      && !this._data.configuration["activeSupervisor"]
      && this._data.session["queuemode"] == 'Q') {
      this._turn.call();
    }

    this.initIoConnection();
  }

  ngOnDestroy() {
    this._turn.stopDeskAutomations();
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Initialize SocketConnection
  public initIoConnection(): void {
    if (this.socketRetries != null)
      this.socketRetries++;

    if (this.subscriptionClose != null)
      this.subscriptionClose.unsubscribe();
    if (this.subscriptionOpen != null)
      this.subscriptionOpen.unsubscribe();
    if (this.ioConnection != null)
      this.ioConnection.unsubscribe();

    this.ioConnection = this._bevent.onMessage()
      .subscribe((response: any) => {
        if (response["eventhook"] == "viewerfb") {
          this._data.turnStatusInViewer.unshift(response["message"]);
          this._data.turnStatusInViewer = this._data.turnStatusInViewer.slice(0, 100);
        }

        if (response["eventhook"] == "disconect") {
          this._data.deskInUseDeskName = response["message"]["desk_name"];
          this._data.deskInUseHostAddr = response["message"]["hostaddr"];
          this._data.deskInUseOffice = response["message"]["office"];
          this._data.deskInUseDate = response["message"]["logindate"];
          this._data.deskInUseHour = response["message"]["logintime"];
          this._data.deskInUse = true;
        }

        if (response["eventhook"] == "force_disconect") {
          this.softLogout();
        }

        if (response["eventhook"] == "turninfo")
          this.parseIsWaiting(response["message"]);
      });

    this.subscriptionOpen = this._bevent.onOpen()
      .subscribe((response: any) => { });

    this.subscriptionClose = this._bevent.onClose()
      .subscribe((response: any) => {
        this.initIoConnection();
      });
  }

  actionCall(desk: number) {
    this._turn.actionCallList(desk);
  }

  /* When the turn information change */
  private _updateTurn(turn: object): void {
    if (turn == null) {
      this.enableRecallButton = false;
    } else {
      this.enableRecallButton = true;
    }
  }

  /* When the turn information change */
  private _selectedUpdateTurn(selectedTurn: object): void {
    if (selectedTurn != null && (selectedTurn["type"] == 'inWait' || selectedTurn["type"] == 'cancelled')) {
      this.enableCallButton = true;
    } else {
      this.enableCallButton = false;
    }

    if (selectedTurn != null
      && selectedTurn["type"] == 'inAttention'
      && this._data.configuration["activeSupervisor"]) {
      this._data.enableRecallSupervisor = true;
    } else {
      this._data.enableRecallSupervisor = false;
    }

  }

  /* Get the queue size */
  private _isWaiting(): void {
    this._blogic.turnIsWaiting()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.parseIsWaiting(response["message"]);
        }
      );
  }

  private parseIsWaiting(response): void {
    let parse = response;
    let data = this._data.session;
    let candidate = 0;

    let item = (this._data.session["schema"] == 'Q') ? parse["qinfo"] : parse["kinfo"];

    // Calculate item with > size
    let filtered = [];

    data["schemaitms"].split(',').forEach(element => {
      let filter = item.filter(x => x.id == element);
      if (filter)
        filtered.push(filter[0]);
    });
    filtered = filtered.filter(x => x != null);
    candidate = filtered.reduce((a, b) => a + (b['size'] || 0), 0);

    candidate = (candidate) ? candidate : 0;

    if (this._data.inQueue < candidate && this._notify.hasPermission() && this._data.turn == null) {
      this._notify.notify(this._lang.transform("notifyTitle"), this._lang.transform("notifyBody"))
    }
    this._data.inQueue = candidate;
  }

  public showAlert(value) {
    this.subscriptionClose.unsubscribe();
    this.subscriptionOpen.unsubscribe();
    this.ioConnection.unsubscribe();
    this._bevent.close();

    this.socketRetries = null;
  }

  public logout() {
    this._blogic
          .logout()
          .pipe(takeUntil(this.destroy$))
          .subscribe();
    this._data.deleteStoredCredentials();
    localStorage.removeItem("office");
    localStorage.removeItem("desk");
    window.location.reload();
  }

  public softLogout() {
    if (this.subscriptionClose != null)
      this.subscriptionClose.unsubscribe();
    if (this.subscriptionOpen != null)
      this.subscriptionOpen.unsubscribe();
    if (this.ioConnection != null)
      this.ioConnection.unsubscribe();

    this._bevent.close();
    this._chat.close();

    this._data.timeExceed = true;
  }
}
